<template>
  <el-row
    type="flex"
    justify="center"
  >
    <el-col
      :xs="{ span: 20 }"
      :sm="{ span: 20 }"
      :md="{ span: 16 }"
    >
      <el-container class="card auto-width">
        <el-row>
          <el-col>
            <span
              class="title"
            >{{ strings.title }}</span>
          </el-col>
          <el-col class="py-2">
            <el-steps
              :active="2"
              finish-status="success"
              align-center
            >
              <el-step />
              <el-step />
              <el-step />
              <el-step />
              <el-step />
            </el-steps>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :xs="{ span: 20, offset: 2 }"
            :sm="{ span: 20, offset: 2 }"
            :md="{ span: 18, offset: 3 }"
          >
            <el-form
              v-if="shopperConfig"
              ref="form"
              :model="form"
              :rules="rules"
              size="small"
            >
              <el-row
                justify="space-around"
                type="flex"
                :gutter="24"
              >
                <el-col>
                  <label>{{ shopperConfig.first_name.label }}</label>
                  <el-form-item
                    prop="firstName"
                  >
                    <el-input
                      ref="firstName"
                      v-model="form.firstName"
                      autofocus
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="on"
                      spellcheck="false"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <label>{{ shopperConfig.last_name.label }}</label>
                  <el-form-item
                    prop="lastName"
                  >
                    <el-input
                      ref="lastName"
                      v-model="form.lastName"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="on"
                      spellcheck="false"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                justify="space-around"
                type="flex"
                :gutter="24"
              >
                <el-col>
                  <label>{{ shopperConfig.phone_number.label }}</label>
                  <el-form-item
                    prop="phone"
                  >
                    <el-input
                      ref="phone"
                      v-model.number.trim="form.phone"
                      :maxlength="shopperConfig.phone_number.max_length"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <label>{{ shopperConfig.email_address.label }}</label>
                  <el-form-item
                    prop="email"
                  >
                    <el-input
                      ref="email"
                      v-model.trim="form.email"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                justify="space-around"
                type="flex"
                :gutter="24"
              >
                <el-col>
                  <label>{{ shopperConfig.city.label }}</label>
                  <el-form-item
                    prop="city"
                  >
                    <el-input
                      ref="city"
                      v-model="form.city"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="on"
                      spellcheck="false"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <label>{{ shopperConfig.state.label }}</label>
                  <el-form-item
                    prop="state"
                  >
                    <el-input
                      ref="state"
                      v-model="form.state"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="on"
                      spellcheck="false"
                      :maxlength="shopperConfig.state.max_length"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                justify="space-around"
                type="flex"
                :gutter="24"
              >
                <el-col>
                  <label>{{ shopperConfig.address_1.label }}</label>
                  <el-form-item
                    prop="address1"
                  >
                    <el-input
                      ref="address1"
                      v-model="form.address1"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="on"
                      spellcheck="false"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <label>{{ shopperConfig.address_2.label }}</label>
                  <el-form-item
                    prop="address2"
                  >
                    <el-input
                      ref="address2"
                      v-model="form.address2"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="on"
                      spellcheck="false"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                justify="space-around"
                type="flex"
                :gutter="24"
              >
                
                <el-col>
                  <label>{{ shopperConfig.drivers_license.label }}</label>
                  <el-form-item
                    prop="license"
                  >
                    <el-input
                      ref="license"
                      v-model.trim="form.license"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      class="form-input full-width no-min-width upper"
                      type="text"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <label>{{ shopperConfig.zip_code.label }}</label>
                  <el-form-item
                    prop="zipcode"
                  >
                    <el-input
                      ref="zipcode"
                      v-model.trim="formattedZipcode"
                      :maxlength="shopperConfig.zip_code.max_length"
                      type="text"
                      class="form-input full-width no-min-width"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row  type="flex" :gutter="24">
                <el-col>
                  <label>Birth month</label>
                  <el-form-item prop="birth_month">
                      <el-select v-model="form.birth_month" class="m-2 form-input full-width no-min-width" placeholder="Select" >
                        <el-option
                          v-for="month in birth_month_options"
                          :key="Object.keys(month)[0]"
                          :label="month[Object.keys(month)[0]]"
                          :value="Object.keys(month)[0]"
                        />
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col >
                  <label>Birth day</label>
                  <el-form-item prop="birth_day">
                      <el-select v-model="form.birth_day" class="m-2 form-input full-width no-min-width" placeholder="Select" >
                        <el-option
                          v-for="day in birth_day_options"
                          :key="day"
                          :label="day"
                          :value="day"
                        />
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col type="flex">
                  <label>Birth year</label>
                  <el-form-item prop="birth_year">
                    <el-input-number class="form-input full-width no-min-width" v-model="form.birth_year" :min="1900" :max="maxDob" label="Birth year" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="mt-1">
                <el-col
                  :span="12"
                  class="text-left"
                >
                  <el-button
                    type="default"
                    native-type="button"
                    @click="backToHome"
                  >
                    {{ strings.form.backBtn }}
                  </el-button>
                </el-col>
                <el-col
                  :span="12"
                  class="text-right"
                >
                  <el-button
                    type="info"
                    class="form-button sm"
                    :disabled="loading"
                    native-type="submit"
                    @click.prevent="create()"
                  >
                    <span v-if="!loading">{{ strings.form.saveBtn.label }}</span>
                    <span v-if="loading">{{ strings.form.saveBtn.loading }}</span>
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import formattedZipcode from '../mixins/formatted_zipcode';

export default {
  name: 'NewCustomerPage',
  mixins: [formattedZipcode],
  data() {
    return {
      birth_day_options: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
      ],
      birth_month_options: [
        {1: 'January'},
        {2: 'February'},
        {3: 'March'},
        {4: 'April'},
        {5: 'May'},
        {6: 'June'},
        {7: 'July'},
        {8: 'August'},
        {9: 'September'},
        {10: 'October'},
        {11: 'November'},
        {12: 'December'}
      ],
      loading: false,
      maxDob: Number(moment().subtract(16, 'years').format(('YYYY'))),
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        address1: '',
        address2: '',
        state: 'FL',
        city: 'Tampa',
        zipcode: '',
        dob: '',
        birth_day: '',
        birth_month: '',
        birth_year: Number(moment().subtract(16, 'years').format(('YYYY'))),
        license: '',
        email: ''
      },
      strings: {
        title: 'New Swapper',
        form: {
          dob: {
            displayFormat: 'yyyy/MM/dd',
            modelFormat: 'yyyy-MM-dd'
          },
          backBtn: 'Back',
          saveBtn: { label: 'Create', loading: 'Please wait...' }
        }
      }
    };
  },
  computed: {
    ...mapGetters('shopper', ['shopperConfig']),
    rules() { return this.$helpers.createShopperRules(); },
  },
  async mounted() {
    // Check if shopper config is saved in store
    const config = this.$store.getters['shopper/shopperConfig'];
    if (!config) {
      // Try to ger shopper config one more time
      this.$helpers.getShopperConfig();
    }
    this.$nextTick(function () {
      /*
      * Don't do a form validation on initial (blank) form state
      * This that will run only after thet
      * entire view has been rendered
      */
      this.$refs.form.resetFields();
    });
  },
  methods: {
    backToHome() {
      // Back to home
      this.$router.push('/home');
    },
    async create() {
      try {
        // Check for form errors
        await this.$refs.form.validate();
        // Inform UI about a running process
        this.loading = true;

        // get form.birth_day, form.birth_month, form.birth_year and create form.dob
        this.form.dob = moment(`${this.form.birth_year}-${this.form.birth_month}-${this.form.birth_day}`, 'YYYY-MM-DD').format('YYYY-MM-DD');

        /*
        * This mapping is neccesary due to different
        * cases between backend(snake_case) and frontend(camelCase)
        */
        const shopper = this.$helpers.mapShopper({ shopper: this.form });
        // Save Shopper
        const newShopper = await this.$store.dispatch('shopper/create', shopper);
        this.$store.dispatch('shopper/isNewShopper', true);
        // Store this shopper and send user to ToS page
        this.$store.dispatch('shopper/storeSelected', newShopper);
        // Unlock UI elements
        this.loading = false;
        // Go to ToS
        this.$router.push('/tos');
      } catch (error) {
        this.loading = false;
        // Error doesn't come from server but from form validation
        if (!error) {
          return;
        }
        // Rejection comes from the server
        let errorList = [];
        const { response } = error;
        switch (response.status) {
          case 400:
            /*
            * Will map through all error fields tto build a readable html list below
            */
            Object.values(response.data).map((err) => {
              errorList = [...errorList, ...err];
            });
            errorList = errorList.map((err) => `<li>${err}</li>`);
            // Form UI has errors
            this.$swal({
              type: 'info',
              title: 'Check Information',
              html: `Please check the swapper information, the following errors need to be fixed:
                <ul class="error-list">
                  ${errorList}
                </ul>
              `
            });
            break;
          default:
            this.$swal({
              type: 'info',
              title: 'Check Information',
              html: 'An error has occurred trying to save this swapper. Please try again.'
            });
            break;
        }
      }
    }
  }
};
</script>
<style lang="scss">
  .error-list {
    list-style: none;
    text-align: left;
    font-size: 15px;
    color: #F56C6C;
    text-transform: capitalize; // Response coming from server is all lowercase
  }
  .upper input{
    text-transform: uppercase;
  }
</style>